// @flow
import React from "react";
import styled, { css } from "styled-components";

import { rgba } from "polished";

const TabView = styled.div`
  display: inline-block;
  vertical-align: bottom;
  width: 50%;
  padding-top: 12px;
  padding-bottom: 8px;
  font-size: 0;
  line-height: 0;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
  cursor: pointer;
  opacity: 0.57;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  user-select: none;

  :hover {
    opacity: 1;
    background: ${({ theme }) => rgba(theme.accent, 0.42)};
  }

  :first-of-type:hover {
    border-right-color: ${({ theme }) => theme.mainDark};
  }

  :last-of-type:hover {
    border-left-color: ${({ theme }) => theme.mainDark};
  }

  ${props =>
    props.isActive &&
    css`
      padding-top: 9px;
      background: ${({ theme }) => theme.accent};
      font-size: 0;
      line-height: 0;
      color: ${({ theme }) => theme.mainDark};
      opacity: 1;

      :hover,
      :first-of-type:hover,
      :last-of-type:hover {
        background: ${({ theme }) => theme.accent};
        border-color: transparent;
      }
    `};
`;

const Text = styled.span`
  font-size: 18px;
  line-height: 1.1;

  ${props =>
    props.isActive &&
    css`
      font-size: 20px;
    `};
`;

type Props = {
  id: string,
  isActive: boolean,
  onClick: () => void,
  children: any
};

function Tab({ id, isActive, onClick, children }: Props) {
  return (
    <TabView
      id={`${id}-form-link`}
      data-tab={id}
      isActive={isActive}
      onClick={onClick}
    >
      <Text isActive={isActive}>{children}</Text>
    </TabView>
  );
}

export default Tab;



// WEBPACK FOOTER //
// ./src/components/Auth/Tab.js